import React from 'react'
import { shouldShowUnderline } from '../../domain/filterOptions/useCases/shouldShowUnderline'
import { Check } from 'react-bootstrap-icons'

const FilterItemsList = ({
  items,
  searchQuery,
  selectedItems,
  getItemProps,
  onSelectionChange,
  refine,
  toggleProps,
  multiSelect,
  formatCount,
  topBarRef,
  hideClearButton = false,
  clearFilters,
  taxonomy
}) => {
  const isSelected = (item, selectedItems) => selectedItems.includes(item.label)

  const sortedItems = [...items].sort((a, b) => {
    return isSelected(b, selectedItems) - isSelected(a, selectedItems)
  })

  return (
    <>
      <div className="shrink grow overflow-auto p-4 md:p-3">
        <div className="space-y-1">
          {sortedItems.map((item) => {
            if (shouldShowUnderline(item, searchQuery))
              return (
                <Underline
                  searchQuery={searchQuery}
                  key="underline"
                />
              )

            return (
              <Item
                key={item.label}
                item={item}
                selected={isSelected(item, selectedItems)}
                getItemProps={getItemProps}
                onSelectionChange={onSelectionChange}
                refine={refine}
                toggleProps={toggleProps}
                multiSelect={multiSelect}
                formatCount={formatCount}
                topBarRef={topBarRef}
                taxonomy={taxonomy}
              />
            )
          })}
        </div>
      </div>
      {!hideClearButton && selectedItems.length > 0 && (
        <ClearSelectedButton
          selectedItems={selectedItems}
          refine={refine}
          clearFilters={clearFilters}
          toggleProps={toggleProps}
          taxonomy={taxonomy}
          onSelectionChange={onSelectionChange}
        />
      )}
    </>
  )
}

const ClearSelectedButton = ({
  selectedItems,
  refine,
  clearFilters,
  onSelectionChange: customeRefine,
  toggleProps,
  taxonomy
}) => {
  return (
    <div className="flex h-12 min-h-[48px] items-center self-stretch border-t border-gray-300 px-4 py-0">
      <button
        className="px-2 py-1.5 text-sm font-normal text-primary-500"
        onClick={(e) => {
          if (customeRefine) {
            clearFilters(taxonomy, customeRefine)
            toggleProps.onClick(e)
          } else {
            refine([])
            toggleProps.onClick(e)
          }
        }}
      >
        Clear {selectedItems.length > 1 ? 'All' : 'Selection'}
      </button>
    </div>
  )
}

const Underline = ({ searchQuery = '' }) => (
  <div
    className={`border-b border-gray-300 ${searchQuery.trim() ? 'hidden' : ''}`}
  />
)

const Item = ({
  item,
  selected,
  getItemProps,
  onSelectionChange: customeRefine,
  refine,
  toggleProps,
  multiSelect,
  formatCount,
  taxonomy
}) => (
  <div
    {...getItemProps({ item })}
    className="flex cursor-pointer items-center"
    onClick={(e) => {
      if (customeRefine) {
        customeRefine(item.label, () => {
          return {
            ...item,
            taxonomy: taxonomy.toLowerCase()
          }
        })
      } else {
        return refine(item.label)
      }
      toggleProps.onClick(e)
    }}
  >
    <div
      className={`flex h-fit w-full items-center justify-between rounded-lg px-4 py-2 md:px-3 ${
        selected
          ? 'bg-primary-50 hover:bg-primary-100 active:bg-primary-200'
          : 'bg-white hover:bg-gray-100 active:bg-gray-200'
      }`}
      id={item.label}
    >
      <div className="text-base font-normal text-gray-1100 md:text-sm">
        {item?._highlightResult?.label?.value ? (
          <span
            className="text-sm"
            dangerouslySetInnerHTML={{
              __html: `${item._highlightResult?.label?.value} (${formatCount(
                item.count
              )})`
            }}
          />
        ) : (
          `${item.label} (${formatCount(item.count)})`
        )}
      </div>
      {selected && multiSelect && <Check className="h-5 w-5" />}
    </div>
  </div>
)

export default FilterItemsList
